AFRAME.registerComponent('video180', {
    init: function () {
        const el = this.el;
        el.getObject3D('mesh').geometry = new THREE.SphereGeometry(5000, 64, 64, Math.PI / 2, Math.PI);
        //el.getObject3D('mesh').scale.x = -1;  // Flip for correct viewing
    }
});